import type { PlaycastMessage, PlaycastMessageServicePing, PlaycastMessageSource } from '../types';
import { formatMessage } from './_util/formatMessage';
export * from './macroGraph';

const target = 'service';

export const ping = (hostId: string, userAuth?: string): PlaycastMessage<PlaycastMessageServicePing> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageServicePing = {
    target,
    action: 'ping',
    isReply: false,
    message: {},
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageServicePing>;
};
